<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/buycourse' }"
          >购买课程</el-breadcrumb-item
        >
        <el-breadcrumb-item>课程详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">课包基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="showPkg" label-width="90px">
              <el-form-item label="课包名称:">
                <p>{{ showPkg.name }}</p>
              </el-form-item>
              <el-form-item label="课包ID:">
                <p>{{ showPkg.id }}</p>
              </el-form-item>
              <br />
              <el-form-item label="级别:">
                <p>{{ showPkg.level }}</p>
              </el-form-item>
              <br />
              <el-form-item label="封面:">
                <img :src="showPkg.image" width="80px" height="80px" />
              </el-form-item>
              <br />
              <el-form-item label="周期:">
                <p>{{ showPkg.period }}课程</p>
              </el-form-item>
              <br />
              <!-- <el-form-item label="数量:">
                <p>{{ showPkg.count }}</p>
              </el-form-item> -->
              <el-form-item label="课程类型:">
                <!-- <p> <span v-if="showPkg.packageType == 1">体系课</span>
              <span v-if="showPkg.packageType == 2">特色课程</span></p> -->
              <span >体系课</span>
              </el-form-item>
              <!-- <el-form-item label="使用时间:">
                <p>{{ showPkg.count }}</p>
              </el-form-item> -->
              <br />
            </el-form>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">已添加课</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formCourse" label-width="90px">
              <el-form-item label="展示顺序：">
                <el-input
                  v-model="formCourse.period"
                  placeholder="请输入阿拉伯数字搜索"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="级别:">
                <el-select
                  v-model="formCourse.level"
                  clearable
                  style="width: 175px"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="名称：">
                <el-input
                  v-model="formCourse.name"
                  placeholder="请输入名称搜索"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="search" @click="onQuery"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>

            <el-table
              ref="multipleTable"
              :data="courseData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="id"
                label="ID"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewAlbum(scope.row.albumId)"
                    style="color: #1d90e6"
                    >{{ scope.row.id }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="order"
                label="展示顺序"
                align="center"
                min-width="110"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.order + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="level"
                label="级别"
                align="center"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewAlbum(scope.row.albumId)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="image"
                label="图片"
                align="center"
                min-width="110"
              >
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    min-width="70"
                    :height="scope.row.image != '' ? 70 : 20"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                label="内容数量"
                align="center"
                width="120"
              ></el-table-column>
              <el-table-column
                prop=""
                label="更新时间"
                align="center"
                width="150"
                 v-if="$route.query.type == 'Course'"
              >
                <template slot-scope="scope">
                  <div class="btnFlex">
                    <span
                      style="padding-right: 10px"
                     
                      >{{ scope.row.updated_at }}</span
                    >
                  </div>
                </template>
              </el-table-column>
               <el-table-column
                prop=""
                label="解锁时间"
                align="center"
                width="180"
                v-if="$route.query.type == 'Class'"
              >
                <template slot-scope="scope">
                 
                     <div class="btnFlex">
                      <span style="padding-right: 10px">{{
                        scope.row.date
                      }}</span>
                      <stUpdated
                        @stUpdatedResult="editstUpdated"
                        :rowDta="scope.row"
                      ></stUpdated>
                    </div>
                 
                </template>
              </el-table-column>
              <el-table-column
                prop="enabled"
                label="上下架状态"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.enabled" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-else type="danger">已下架</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal"
              ></el-pagination>
            </div>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 49%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >确定</el-button
      >
      
      
      <!-- <el-button
        type="primary"
        style="margin-left: 49%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >确定</el-button
      > -->
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import stUpdated from "../componentsEdu/stUpdated";

export default {
  name: "detailbuyCourse",
  components: { stUpdated },
  data() {
    return {
      showPkg: {
        id: "",
        name: "",
        level: "",
        image: "",
        period: null,
        count: null,
        courseType:""
      },
      levelList: [
        {
          value: "初级",
          label: "初级",
        },
        {
          value: "中级",
          label: "中级",
        },
        {
          value: "高级",
          label: "高级",
        },
        {
          value: "桥梁",
          label: "桥梁",
        },
        {
          value: "初章",
          label: "初章",
        },
        {
          value: "中章",
          label: "中章",
        },
      ],
      courseData: [],
      formCourse: {
        period: "",
        name: "",
        level: "",
      },
      currId: null,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      periodTxt: "",
      classId: null,
      type: "",
    };
  },
  created() {
    if (this.$route.query.classId != undefined) {
      this.classId = `${this.$route.query.classId}`;
    }
    if (this.$route.query.type != undefined) {
      // debugger
      this.type = `${this.$route.query.type}`;
      console.log(this.$route.query.type, "8888888888");
    }
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
        packageType: 2,

      };

      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
            // debugger
          let m = JSON.parse(res).list[0];
          this.showPkg.id = m.id;
          this.showPkg.name = m.name;
          this.showPkg.level = m.level;
          this.showPkg.image = m.image;
          this.showPkg.packageType = m.packageType;
          
          if (m.period == 1) {
            this.showPkg.period = "日";
            this.periodTxt = "日";
          } else if (m.period == 2) {
            this.showPkg.period = "周";
            this.periodTxt = "周";
          } else if (m.period == 3) {
            this.showPkg.period = "月";
            this.periodTxt = "月";
          }
          this.showPkg.count = m.count;
          this.fetchCourseList();
        }
      });
    }
  },
  watch: {},
  methods: {
    editstUpdated(val) {
      let updatedTime = val.updatedTime;
      let order = val.order;
      let courseId = val.courseId;
      let params = {
        appId: this.$API.APPID,
        courseId: courseId, //必须，课ID
        order: order, //必须，课的序号
        classId: this.classId, //必须，班级ID
        date: formatDate(updatedTime, "yyyy-MM-dd"), //必须，课的更新时间
      };
      //  debugger
      this.$axios
        .post("/edu/eduAdmin/course/save_cls_update_date", params)
        .then((response) => {
          if (response != null) {
            if (response.data.rc == 0) {
              this.$Message.success("操作成功!");
              this.fetchCourseList();
            } else {
              alert(response.data.err);
            }
          }
        });
    },
    confirmSubmit() {
      this.$router.push({
        name: "courseList",
      });
    },
    onQuery() {
      this.fetchCourseList();
    },
    fetchCourseList() {
      let params2 = {
        appId: this.$API.APPID,
        packageId: `${this.currId}`,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        classId: this.classId,
        courseType:2
        // level:this.level
      };
      if (this.formCourse.period != "") {
        params2.order = Number(this.formCourse.period) - 1;
      }
      if (this.formCourse.name != "") {
        params2.name = this.formCourse.name;
      }
      if (this.formCourse.level != "") {
        params2.level = this.formCourse.level;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/course_list",
        params2
      ).then((res2) => {
        if (res2 != null) {
          let m2 = JSON.parse(res2);
          this.courseData = m2.list;
          this.pageTotal = m2.pager.total;
          this.step = 2;
        }
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchCourseList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchCourseList();
    },
    viewAlbum(albumId) {
      // debugger
      console.log(albumId);
      let routeUrl = this.$router.resolve({
        name: "packageCourseDetail",
        query: {
          id: albumId,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// detailbuyCourse.vue?2c965330